
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { MODEL } from "@/module";
import { ref } from "vue";
import VueCropper from "vue-cropperjs";
import html2canvas from "html2canvas";
import "cropperjs/dist/cropper.css";
import { Chrome } from "vue-color";

@Component({
  components: {
    VueCropper,
    VuePicker: Chrome,
  },
})
export default class CardMaker extends Vue {
  @Prop({ required: true }) cardType?: MODEL.CardType;
  private imgSrc = ref();
  private cropedImg?: string | ArrayBuffer | null = "";
  private cropedImgElement: HTMLImageElement = new Image();
  private file = null;
  private memberNo = "";
  private division = "";
  private memberName = "";
  private trim = false;
  private forStaff = false;
  private downloadFileName = "";
  private dataURL = "";
  private dialog = false;
  private tweetDialog = false;
  private shareLoading = false;
  private canvas = false;
  // private play = false;
  private sheet_bg = false;
  private sheet_shape = false;
  private sheet_settings = false;
  private pickerDialog = false;
  private plays = null;
  private playFrameMS = 100;
  private issueImageScale = 1;
  private uniBGAssets = [
    {
      name: "snow",
      path: "snow_dome.png",
    },
    {
      name: "sea",
      path: "uniBG03.png",
    },
    {
      name: "sea2",
      path: "uniBG02.png",
    },
    {
      name: "leaf",
      path: "uniBG04.png",
    },
    {
      name: "battle",
      path: "uniBG05.png",
    },
    {
      name: "milkyway",
      path: "uniBG06.png",
    },
    {
      name: "bluesky",
      path: "naru01.jpg",
    },
    {
      name: "sunset",
      path: "naru02.jpg",
    },
    {
      name: "strawberry",
      path: "naru03.jpg",
    },
    {
      name: "fullmoon",
      path: "naru04.jpg",
    },
    {
      name: "wilderness",
      path: "waffu01.jpeg",
    },
    {
      name: "wilderness_uni",
      path: "waffu02.jpeg",
    },
    {
      name: "river_kani",
      path: "waffu03.jpeg",
    },
  ];
  private overlayImgList: HTMLImageElement[] = [];
  private e1 = 1;
  private uniBG = 0;
  private uniProp = {
    canvas: {
      width: 1200,
      height: 1200,
    },
    lineNum: 450,
    lineWidth: 140,
    center: {
      x: 600,
      y: 600,
    },
    circleRadius: {
      amplitude: 50,
      min: 160,
    },
    lineColorHex8: "#000000FF",
    lineColor: {
      a: 1,
      hex: "#000000",
      hex8: "#000000FF",
      hue: 1,
      hsva: { h: 0, s: 0, v: 0, a: 1 },
      rgba: { r: 0, g: 0, b: 0, a: 1 },
    },
  };
  get computedUniProp() {
    return JSON.parse(JSON.stringify(this.uniProp));
  }
  created() {
    const staff = this.$route.query.staff;
    if (staff != null) {
      this.forStaff = true;
    }
  }

  mounted() {
    this.imgSrc = require(`@/assets/${this.cardType?.assets.default_photo}`);
    this.uniBGAssets.forEach((asset) => {
      const img = new Image();
      img.src = require(`@/assets/${asset.path}`);
      this.overlayImgList.push(img);
    });
  }

  get play(): boolean {
    if (this.plays == null) {
      return false;
    } else {
      return true;
    }
  }

  @Watch("cardType")
  onChangeCardType() {
    this.imgSrc = require(`@/assets/${this.cardType?.assets.default_photo}`);
  }

  @Watch("computedUniProp", { deep: true })
  onChangeUniProp(after: any, before: any) {
    let refresh = true;
    if (JSON.stringify(before.lineColor) != JSON.stringify(after.lineColor)) {
      refresh = false;
      this.uniBG = 0;
      // this.imageOverlay = false;
    }
    // if (this.cropedImg != "") {
    this.plays = null;
    this.drawFocusLine(refresh);
    // }

    // if (this.sheet_bg) {
    //   this.sheet_bg = false;
    // }
  }

  @Watch("play")
  onChangePlay(play: boolean) {
    if (play) {
      this.drawFocusLine(true);
    }
  }

  @Watch("uniBG")
  onChangeBGImage() {
    console.log("bgchange");
    this.drawFocusLine(false);
  }

  @Watch("imageOverlay")
  onChangeImageOverlay() {
    this.drawFocusLine(false);
  }

  private uniClick(event: PointerEvent) {
    // console.log(event.offsetX, event.offsetY);
    this.uniProp.center = { x: event.offsetX / this.zoom, y: event.offsetY / this.zoom };
  }

  private logging = "";
  private pinchDist = 0;
  private pinching = false;
  private touchCount = 0;
  private uniTouchStart(event: any) {
    if (event.changedTouches.length >= 2) {
      this.pinching = true;
      const t1 = { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY };
      const t2 = { x: event.changedTouches[1].clientX, y: event.changedTouches[1].clientY };
      const dist = Math.sqrt(Math.pow(t2.x - t1.x, 2) + Math.pow(t2.y - t2.y, 2));
      this.pinchDist = dist;
    }
    this.touchCount = event.touches.length;
  }
  private uniTouchEnd(event: any) {
    if (event.touches.length == 0) {
      this.pinching = false;
      this.pinchDist = 0;
    }
    this.touchCount = event.touches.length;
  }
  private uniTouch(event: any) {
    const changedTouchesCount = event.changedTouches.length;
    this.touchCount = event.touches.length;
    // console.log(event);
    // this.logging = `${touchCount}`;
    if (this.touchCount >= 2) {
      if (!this.pinching) {
        this.pinching = true;
      }
    }
    if (changedTouchesCount >= 2) {
      const t1 = { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY };
      const t2 = { x: event.changedTouches[1].clientX, y: event.changedTouches[1].clientY };
      const dist = Math.sqrt(Math.pow(t2.x - t1.x, 2) + Math.pow(t2.y - t2.y, 2));
      if (this.pinchDist < dist) {
        this.uniProp.circleRadius.min = Math.min(600, this.uniProp.circleRadius.min + 10);
      } else {
        this.uniProp.circleRadius.min = Math.max(0, this.uniProp.circleRadius.min - 10);
      }
      this.pinchDist = dist;
    } else {
      if (!this.pinching) {
        const touch = event.changedTouches[0];
        const bounds = touch.target.getBoundingClientRect();
        const x = touch.clientX - bounds.left * this.zoom;
        const y = touch.clientY - bounds.top * this.zoom;
        // console.log("要素内で... x=" + x, "y=" + y);
        if (
          Math.abs(this.uniProp.center.x - x / this.zoom) > 10 ||
          Math.abs(this.uniProp.center.y - y / this.zoom) > 10
        )
          this.uniProp.center = { x: x / this.zoom, y: y / this.zoom };
      }
    }
  }

  private drawFocusLine(refresh?: boolean) {
    const canvas = this.$refs.uniCanvas as HTMLCanvasElement;
    this.focusLine(
      canvas,
      this.uniProp.center.x,
      this.uniProp.center.y,
      this.uniProp.lineWidth,
      this.uniProp.lineNum,
      this.uniProp.circleRadius.min + this.uniProp.circleRadius.amplitude,
      this.uniProp.circleRadius.min,
      this.uniProp.lineColor.hex,
      refresh
    );
  }

  private get imageOverlay(): boolean {
    return this.uniBG != 0;
  }

  private get cropper() {
    return this.$refs.cropper as any;
  }

  private get fileInput() {
    return this.$refs.fileInput as any;
  }

  get trimClass(): string {
    return this.trim ? "overflowHidden" : "";
  }

  get filled(): boolean {
    return this.file != null && this.memberNo !== "" && this.memberName !== "" && this.division !== "";
  }

  get mobile(): boolean {
    return this.$vuetify.breakpoint.mobile;
  }

  get numberLabel(): string {
    return this.$t(`organization.${this.cardType?.organization_type}.membership_no`).toString();
  }

  get logoStyleString(): string {
    return `letter-spacing: ${this.$t("common.logo_spacing", "ja")};`;
  }

  get titleStyleString(): string {
    return `color: ${this.cardType?.colors.title_font};`;
  }

  get memberNameStyle(): string {
    return this.cardType?.layout?.title_pr ? `padding-right: ${this.cardType?.layout?.title_pr}` : "";
  }

  get cardOverlay(): string | undefined {
    return this.cardType?.assets.overlay;
  }

  get dispWidth(): number {
    return this.$vuetify.breakpoint.width;
  }

  get mdColWidth(): number {
    if (this.$vuetify.breakpoint.mdAndUp) return this.dispWidth / 2;
    else return this.dispWidth;
  }

  get zoom(): number {
    if (this.canvas) {
      return 1;
    } else {
      const root = this.$refs.root as HTMLElement;
      const [marginTortalm, previewOriginalWidth, maxZoom] = [48, this.uniProp.canvas.width, 0.5];
      return Math.min((this.mdColWidth - marginTortalm) / previewOriginalWidth, maxZoom);
    }
  }
  // get overlayImg(): HTMLImageElement {
  //   if (this.uniBG > 0 && this.uniBG <= this.overlayImgList.length) {
  //     return this.overlayImgList[this.uniBG - 1];
  //   } else {
  //     return this.overlayImgList[0];
  //   }
  // }
  get overlayImg(): string {
    if (this.uniBG > 0 && this.uniBG <= this.overlayImgList.length) {
      return this.uniBGAssets[this.uniBG - 1].path;
    } else {
      return this.uniBGAssets[0].path;
    }
  }
  private onChangeFileInput() {
    this.file = this.fileInput.files[0];
    if (this.file == null) {
      this.cropper.destroy();
    } else {
      this.cropper.replace(URL.createObjectURL(this.file));
    }
  }

  get canShare(): boolean {
    return navigator.share !== undefined ? true : false;
  }

  private cropImage() {
    // get image data for post processing, e.g. upload or setting image src
    if (this.file !== null) {
      this.cropedImg = this.cropper.getCroppedCanvas().toDataURL();
      this.cropedImgElement.src = this.cropedImg as string;
      this.cropedImgElement.onload = () => {
        this.drawFocusLine(true);
      };
    }
  }
  private rotate(deg: number) {
    // guess what this does :)
    this.cropper.rotate(deg);
  }

  private move(offsetX: number, offsetY: number) {
    this.cropper.move(offsetX, offsetY);
  }

  private relativeZoom(ratio: number) {
    this.cropper.relativeZoom(ratio);
  }

  private reset(ratio: number) {
    this.cropper.reset();
  }
  private async createCardImage(download: boolean) {
    this.plays = null;
    this.canvas = true;
    Vue.nextTick(async () => {
      const preview: HTMLElement = this.$refs.uniFrame as HTMLElement;
      const params: Parameters<typeof html2canvas> = [
        preview,
        {
          scale: this.issueImageScale,
          width: this.uniProp.canvas.width,
          height: this.uniProp.canvas.height,
          backgroundColor: "transparent",
        },
      ];
      const canvasElement = await html2canvas(...params).catch((e) => {
        console.error(e);
        this.canvas = false;
        return;
      });
      if (!canvasElement) {
        this.canvas = false;
        return;
      }
      const dataURL = canvasElement.toDataURL("image/png");
      this.canvas = false;
      if (download) {
        let link = document.createElement("a");
        link.href = dataURL;
        link.target = "_blank";
        if (this.downloadFileName !== "") {
          link.download = `${this.downloadFileName}.png`;
        } else {
          link.download = `${this.memberNo}_${this.division}_${this.memberName}.png`;
        }
        link.click();
      } else {
        this.dataURL = dataURL;
        this.dialog = true;
      }
    });
  }

  private getInvertedColor(): string {
    const rgba = this.uniProp.lineColor.rgba;
    // 明るさの計算(0〜255)
    const brightness = (rgba.r * 299 + rgba.g * 587 + rgba.b * 114) / 1000;
    // 明るさの計算(0〜100)
    const luminance = brightness / 2.55;

    // 基準値(50)より大きい場合は、黒を返し、それ以外は白を返す
    return luminance > 50 ? "#000000" : "#ffffff";
  }

  private closeDialog() {
    this.dialog = false;
    this.dataURL = "";
  }

  private cardBGLoaded() {
    this.$nextTick(() => {
      this.trim = true;
    });
  }

  private lines: LineInterface[] = [];
  private focusLine(
    canvas: HTMLCanvasElement,
    centralX: number,
    centralY: number,
    lineWidth: number,
    lineNum: number,
    circleRadiusMax: number,
    circleRadiusMin: number,
    lineColor: string,
    refresh?: boolean
  ) {
    const ctx = canvas.getContext("2d");
    let lines: Liner[] = [];

    const csRadius = Math.sqrt(
      Math.pow(Math.max(canvas.width - centralX, centralX), 2) +
        Math.pow(Math.max(canvas.height - centralY, centralY), 2)
    );

    class Liner implements LineInterface {
      private deg = 0;
      private moveDeg = 0;
      private endRadius = 0;
      private startPos: Pos = { x: 0, y: 0 };
      private endPos: Pos = { x: 0, y: 0 };
      private movePos: Pos = { x: 0, y: 0 };
      private lineColor = "#000000FF";

      constructor() {
        this.initialize();
      }

      private initialize() {
        this.deg = this.getRandomInt(360, 0);
      }

      private getRandomInt = (max: number, min: number): number => {
        return Math.floor(Math.random() * (max - min)) + min;
      };

      getCircumPos = {
        x: (deg: number, rad: number, cx: number): number => {
          return Math.cos((Math.PI / 180) * deg) * rad + cx;
        },
        y: (deg: number, rad: number, cy: number): number => {
          return Math.sin((Math.PI / 180) * deg) * rad + cy;
        },
      };

      setPos() {
        this.moveDeg = this.deg + this.getRandomInt(lineWidth, 1) / 10;
        this.endRadius = this.getRandomInt(circleRadiusMax, circleRadiusMin);
        this.startPos = {
          x: this.getCircumPos.x(this.deg, csRadius, centralX),
          y: this.getCircumPos.y(this.deg, csRadius, centralY),
        };
        this.movePos = {
          x: this.getCircumPos.x(this.moveDeg, csRadius, centralX),
          y: this.getCircumPos.y(this.moveDeg, csRadius, centralY),
        };
        this.endPos = {
          x: this.getCircumPos.x(this.moveDeg, this.endRadius, centralX),
          y: this.getCircumPos.y(this.moveDeg, this.endRadius, centralY),
        };
      }

      setColor(color: string) {
        this.lineColor = color;
      }

      update() {
        this.setPos();
      }

      draw() {
        if (ctx) {
          ctx.beginPath();
          ctx.lineWidth = 1;
          ctx.fillStyle = this.lineColor;
          ctx.moveTo(this.startPos.x, this.startPos.y);
          ctx.lineTo(this.movePos.x, this.movePos.y);
          ctx.lineTo(this.endPos.x, this.endPos.y);
          ctx.fill();
          ctx.closePath();
        }
      }

      render(refresh: boolean) {
        if (refresh) {
          this.update();
        }
        this.draw();
      }
    }

    const createLines = (num: number) => {
      this.lines = [];
      [...Array(num)].map(() => this.lines.push(new Liner()));
    };

    const render2 = (refresh: boolean, img?: HTMLImageElement) => {
      ctx?.clearRect(0, 0, canvas.width, canvas.height);
      if (ctx && img) {
        ctx.globalCompositeOperation = "source-over";
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      }
      if (ctx) ctx.globalCompositeOperation = "destination-out";
      this.lines.forEach((l) => {
        l.setColor(lineColor);
        l.render(refresh);
      });
      // if (this.imageOverlay) {
      //   if (ctx) ctx.globalCompositeOperation = "source-in";
      //   const [width, height] = [this.overlayImg.width, this.overlayImg.height];
      //   // let origin = { x: 0, y: 0 };
      //   if (width - height > 0) {
      //     // 高さの方が短い
      //     // 比率チェック
      //     const scale = canvas.height / height;
      //     const gap = (width * scale - canvas.width) / 2;
      //     ctx?.drawImage(this.overlayImg, gap * -1, 0, width * scale, canvas.height);
      //   } else {
      //     // 幅の方が短い
      //     const scale = canvas.width / width;
      //     const gap = (height * scale - canvas.height) / 2;
      //     ctx?.drawImage(this.overlayImg, 0, gap * -1, canvas.height, height * scale);
      //   }
      // }
      if (this.play)
        setTimeout(() => {
          if (this.play) render2(refresh, img);
        }, this.playFrameMS);
    };

    const shouldRefresh = refresh || this.lines.length == 0;
    if (shouldRefresh) {
      createLines(lineNum);
    }
    if (this.cropedImg) {
      render2(shouldRefresh, this.cropedImgElement);
    } else {
      render2(shouldRefresh);
    }
  }

  get orgNameHashTag(): string {
    return `#${this.$t("uni_maker.app_name", "ja")} #${this.$t("uni_maker.app_name", "en")}`;
  }

  get shareTextEncoded(): string {
    return encodeURIComponent(this.shareText);
  }

  get shareText(): string {
    return `${this.$t("uni_maker.msg_created")}

${this.orgNameHashTag}
`;
  }

  get tweetShareURL(): string {
    let url = `${location.protocol}//${location.host}${location.pathname}`;
    const shareURL = `https://twitter.com/intent/tweet?text=${this.shareTextEncoded}&url=${url}`;
    return shareURL;
  }

  private async getCardBlobFromDataURL(dataUrl: string): Promise<Blob | null> {
    return await (await fetch(dataUrl)).blob();
  }

  private async shareCardImg(): Promise<void> {
    if (this.canShare) {
      this.shareLoading = true;
      Vue.nextTick(async () => {
        const blob = await this.getCardBlobFromDataURL(this.dataURL);
        this.shareLoading = false;
        if (blob) {
          navigator
            .share({
              text: `${this.shareText}
${location.protocol}//${location.host}${location.pathname}`,
              files: [new File([blob], "card.png", { type: "text/plain" })],
            })
            .then(() => {
              console.log("Share was successful.");
            })
            .catch((error) => {
              console.log("Sharing failed", error);
            });
        } else {
          console.error("failed to get blob.");
        }
      });
    } else {
      console.error("navigation.share not supported.");
    }
  }
}
interface Pos {
  x: number;
  y: number;
}
interface LineInterface {
  update(): void;
  setPos(): void;
  draw(): void;
  render(refresh: boolean): void;
  setColor(color: string): void;
}
